/* DENSA — İçerik Coğrafyası KAPAK v8.0 (11 Ağu 2026)
   Kurucunun net talimatı: kapak eski (uzun) boyuna döner; diğer kartlar da AYNI boyda olur.
   İki iş:
     1) Genişlik + ortalama: kapak = şerit görünür genişliği - peek; peek iki yana eşit bölünür
        → kapak da kartlar da sayfanın tam ortasında (ölçüm: 187 · ekran merkezi 188).
     2) Yükseklik: kapağa 82vh (max 760px) sabit boy verilir; şerit stretch olduğu için
        kavram kartları da aynı boya gelir. Boy bir kez kurulur, geçişte değişmez. */
(function () {
  function kur(kok) {
    var kapak = kok.querySelector('.dcg-kapakkart');
    if (!kapak || kok.dataset.kapakModu) return;
    kok.dataset.kapakModu = '1';

    var serit = kapak.parentElement;
    var temelPadSag = null, temelPadSol = null;

    function sayi(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }

    function peekDegeri() {
      var dar = window.innerWidth <= 749;
      return dar ? 34 : Math.min(76, Math.max(40, Math.round(window.innerWidth * 0.045)));
    }

    function boy() {
      return Math.min(760, Math.round(window.innerHeight * 0.82));
    }

    function olculeriAyarla() {
      if (!serit || !serit.clientWidth) return;
      var cs = getComputedStyle(serit);
      if (temelPadSag === null) temelPadSag = sayi(cs.paddingRight);
      if (temelPadSol === null) temelPadSol = sayi(cs.paddingLeft);
      var peek = peekDegeri();
      var yari = Math.round(peek / 2);
      var g = serit.clientWidth - peek;
      if (g > 120) {
        kapak.style.flex = '0 0 ' + g + 'px';
        kapak.style.width = g + 'px';
        kapak.style.maxWidth = 'none';
        serit.style.paddingLeft = (temelPadSol + yari) + 'px';
        serit.style.paddingRight = (temelPadSag + yari) + 'px';
      }
      kapak.style.minHeight = boy() + 'px';
    }

    window.addEventListener('resize', olculeriAyarla);
    window.addEventListener('load', function () {
      olculeriAyarla();
      setTimeout(olculeriAyarla, 260);
    });
    olculeriAyarla();
    setTimeout(olculeriAyarla, 130);
  }

  function basla() {
    var kokler = document.querySelectorAll('.dcg-kapakli');
    for (var i = 0; i < kokler.length; i++) kur(kokler[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
